var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.componentClasses},[_c('icon-camera',{attrs:{"size":'sm4'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }